module.exports = __webpack_public_path__ + "static/media/tianshangshan.034bd91b.png";